<template>
    <div >
        <!-- 门店统计 -->
        <tables :tableData="tableDataShop" tableKey="shopAnalysisShop" ></tables>

        <!-- 主题统计 -->
        <tables :tableData="tableDataTheme" tableKey="shopAnalysisTheme" ></tables>

        <tables :tableData="tableDataMediaDownload" tableKey="shopAnalysisMediaDownload" ></tables>
    </div>
</template>

<script>
    import tables from '@/components/tables.vue'

    export default {
        name: "shopAnalysis",
        components:{
            tables,
        },
        data() {
            return {
                shopList: [],
                //region 门店统计
                tableDataShop:{
                    title:'门店统计',
                    form: {
                        page: 1,                //页数
                        limit: this.$tools.getLimit(this.$options.name), //条数
                        total: 0,               //总数
                        orderCreateTime:[
                            this.$dayjs().format('YYYY-MM-DD') + " 00:00:00",
                            this.$dayjs().format('YYYY-MM-DD') + ' 23:59:59',
                        ],
                        shopIds:[],
                        orders:{
                            column:"totalPrice",
                            asc: false,
                            desc: true,
                        }
                    },
                    summary: true,
                    column: [
                        //条件
                        { label: "门店", prop: 'shopIds', type: 'tag', visible:false, condition:"checkbox", tags: [], width:'',
                            searchChange:(res, row)=>{
                                this.shopChange(res, row);
                            }
                        },
                        {label: "时间", prop: 'orderCreateTime', type: 'date', dateType:'date', visible:false, condition:"dates",
                          disabledDateConfig: {
                            firstSelectRange: { value: 12, unit: 'month' },
                            vipRule: false
                          },
                            change:(e, item, index) => {this.getShop(); this.getTheme(); this.getMediaDownload();},
                        },
                        //列
                        { type: 'index' },
                        { label: "门店", prop: 'shopName', type: 'text', show:true },
                        { label: "金额", prop: 'totalPrice', type: 'text', show:true, sort: 'custom' , sum: true,},
                        { label: "场次", prop: 'totalTimes', type: 'text', show:true, sort: 'custom', sum: true,},
                        { label: "客户", prop: 'totalPeople', type: 'text', show:true, sort: 'custom' , sum: true,},
                        { label: "客单价", prop: 'averagePricePerOrder', type: 'text', show:true, sort: 'custom' , },
                    ],
                    data: [],
                    searchClick: res => {
                      console.log('执行这个了吗123')
                      this.getShop(); this.getTheme(); this.getMediaDownload();
                    },
                    sortClick: res => {this.sortClick(res, 0);},
                },
                //endregion
                //region 主题统计
                tableDataTheme:{
                    title:'主题统计',
                    form: {
                        page: 1,                //页数
                        limit: this.$tools.getLimit(this.$options.name), //条数
                        total: 0,               //总数
                        orders:{
                            column:"totalPrice",
                            asc: false,
                            desc: true,
                        }
                    },
                    summary: true,
                    column: [
                        //列
                        { type: 'index' },
                        { label: "主题", prop: 'themeName', type: 'text', show:true },
                        { label: "门店", prop: 'shopName', type: 'text', show:true },
                        { label: "金额", prop: 'totalPrice', type: 'text', show:true, sort: 'custom' , sum: true,},
                        { label: "场次", prop: 'totalTimes', type: 'text', show:true, sort: 'custom', sum: true,},
                        { label: "客户", prop: 'totalPeople', type: 'text', show:true, sort: 'custom' , sum: true,},
                        { label: "客单价", prop: 'averagePricePerOrder', type: 'text', show:true, sort: 'custom' , },
                    ],
                    searchBtn: false,
                    data: [],
                    searchClick:res=>{
                      this.getTheme()
                    },
                    sortClick: res => {this.sortClick(res, 1);},
                },
                //endregion
                //region 图片视频下载统计
                tableDataMediaDownload:{
                    title:'精彩瞬间',
                    form: {
                        page: 1,
                        limit: this.$tools.getLimit(this.$options.name),
                        total: 0,
                    },
                    summary: true,
                    column: [
                        { type: 'index' },
                        { label: "门店", prop: 'shopName', type: 'text', show:true },
                        { label: "订单数", prop: 'orderCount', type: 'text', show:true, sum: true },
                        { label: "上传数", prop: 'uploadOrderCount', type: 'text', show:true, sum: true , popover: {
                            content: "<div>含已上传又删除的订单数。</div>",
                            placement: "bottom",
                            width: 220
                          }},
                        { label: "下载数", prop: 'downloadOrderCount', type: 'text', show:true, sum: true ,
                          popover: {
                            content: "<div>统计的是密室星球下载的订单数。</div>",
                            placement: "bottom",
                            width: 220
                          }},
                        { label: "上传率", prop: 'uploadOrderCountRate', type: 'text', show:true },
                        { label: "下载率", prop: 'downloadOrderCountRate', type: 'text', show:true },
                    ],
                    searchBtn: false,
                    data: [],
                },
                //endregion
            }
        },
        methods: {

            /**
             * 排序点击
             */
            sortClick(res, type){
                if(type == 1){
                    this.tableDataTheme.form.orders.column = res.prop;
                    if(res.order == "descending"){
                        this.tableDataTheme.form.orders.asc = false;
                        this.tableDataTheme.form.orders.desc = true;
                    }else{
                        this.tableDataTheme.form.orders.asc = true;
                        this.tableDataTheme.form.orders.desc = false;
                    }
                    this.getTheme();
                }else{
                    this.tableDataShop.form.orders.column = res.prop;
                    if(res.order == "descending"){
                        this.tableDataShop.form.orders.asc = false;
                        this.tableDataShop.form.orders.desc = true;
                    }else{
                        this.tableDataShop.form.orders.asc = true;
                        this.tableDataShop.form.orders.desc = false;
                    }
                    this.getShop();
                }

            },

            /**
             * 选择店铺
             */
            shopChange(res, row){
                let list = this.tableDataShop.form.shopIds;
                //全部
                if (row.value == -1) {
                    //全选
                    if(res){
                        this.tableDataShop.form.shopIds = [-1];
                        for (let i = 0; i < this.shopList.length; i++) {
                            this.tableDataShop.form.shopIds.push(this.shopList[i].id)
                        }
                    }
                    //清空
                    else{
                        this.tableDataShop.form.shopIds = [];
                    }
                }
                //单独选择
                else{
                    for (let i = 0; i < list.length; i++) {
                        if(list[i] == -1){
                            list.splice(i, 1);
                        }
                    }
                    let flag = 0;
                    for (let i = 0; i < list.length; i++) {
                        if(list[i] != -1){
                            flag++;
                        }
                    }
                    if (flag == this.shopList.length) {
                        this.tableDataShop.form.shopIds = [-1];
                        for (let i = 0; i < this.shopList.length; i++) {
                            this.tableDataShop.form.shopIds.push(this.shopList[i].id)
                        }
                    }
                }
                this.getShop();
                this.getTheme();
                this.getMediaDownload();
            },

            /**
             * 获取门店统计
             */
            getShop(){
                let param = JSON.parse(JSON.stringify(this.tableDataShop.form));
                if(this.tableDataShop.form.orderCreateTime && this.tableDataShop.form.orderCreateTime.length == 2){
                    param.startDateTime = this.$dayjs(this.tableDataShop.form.orderCreateTime[0]).format('YYYY-MM-DD') + ' 00:00:00';
                    param.endDateTime = this.$dayjs(this.tableDataShop.form.orderCreateTime[1]).format('YYYY-MM-DD') + ' 23:59:59';
                }else{
                    this.$message.warning("请选择时间!");
                    return;
                }
                if(!this.tableDataShop.form.shopIds || this.tableDataShop.form.shopIds.length == 0){
                    this.$message.warning("请选择门店!");
                    return;
                }
                let list = [];
                for (let i = 0; i < this.tableDataShop.form.shopIds.length; i++) {
                    if(this.tableDataShop.form.shopIds[i] != -1){
                        list.push(this.tableDataShop.form.shopIds[i]);
                    }
                }
                param.orders = [param.orders];
                param.shopIds = list;
                param.size = 99;
                this.$POST("/customer/dataPanel/getShopCoreDataPanel/shop", param).then(res => {
                    this.tableDataShop.data = res.data.records;
                    this.tableDataShop.form.total = res.data.total;
                })
            },

            /**
             * 获取主题统计
             */
            getTheme(){
                let param = JSON.parse(JSON.stringify(this.tableDataTheme.form));
                //时间和门店用门店表格的
                if(this.tableDataShop.form.orderCreateTime && this.tableDataShop.form.orderCreateTime.length == 2){
                    param.startDateTime = this.$dayjs(this.tableDataShop.form.orderCreateTime[0]).format('YYYY-MM-DD') + ' 00:00:00';
                    param.endDateTime = this.$dayjs(this.tableDataShop.form.orderCreateTime[1]).format('YYYY-MM-DD') + ' 23:59:59';
                }else{
                    this.$message.warning("请选择时间!");
                    return;
                }
                if(!this.tableDataShop.form.shopIds || this.tableDataShop.form.shopIds.length == 0){
                    this.$message.warning("请选择门店!");
                    return;
                }
                let list = [];
                for (let i = 0; i < this.tableDataShop.form.shopIds.length; i++) {
                    if(this.tableDataShop.form.shopIds[i] != -1){
                        list.push(this.tableDataShop.form.shopIds[i]);
                    }
                }
                param.orders = [param.orders];
                param.shopIds = list;
                param.size = 99;
                this.$POST("/customer/dataPanel/getShopCoreDataPanel/theme", param).then(res => {
                    this.tableDataTheme.data = res.data.records;
                    this.tableDataTheme.form.total = res.data.total;
                })
            },

            getMediaDownload(){
                let param = JSON.parse(JSON.stringify(this.tableDataMediaDownload.form));
                if(this.tableDataShop.form.orderCreateTime && this.tableDataShop.form.orderCreateTime.length == 2){
                    param.startDateTime = this.$dayjs(this.tableDataShop.form.orderCreateTime[0]).format('YYYY-MM-DD') + ' 00:00:00';
                    param.endDateTime = this.$dayjs(this.tableDataShop.form.orderCreateTime[1]).format('YYYY-MM-DD') + ' 23:59:59';
                }else{
                    this.$message.warning("请选择时间!");
                    return;
                }
                if(!this.tableDataShop.form.shopIds || this.tableDataShop.form.shopIds.length == 0){
                    this.$message.warning("请选择门店!");
                    return;
                }
                let list = [];
                for (let i = 0; i < this.tableDataShop.form.shopIds.length; i++) {
                    if(this.tableDataShop.form.shopIds[i] != -1){
                        list.push(this.tableDataShop.form.shopIds[i]);
                    }
                }
                param.shopIds = list;
                param.size = 99;
                this.$POST("/customer/dataPanel/getShopCoreDataPanel/shopOrderUploadDownload", param).then(res => {
                    this.tableDataMediaDownload.data = (res.data.records || []).map(item => ({
                        ...item,
                        uploadOrderCountRate: this.formatMediaRate(item.uploadOrderCountRate),
                        downloadOrderCountRate: this.formatMediaRate(item.downloadOrderCountRate),
                    }));
                    this.tableDataMediaDownload.form.total = res.data.total;
                })
            },

            formatMediaRate(rate){
                const value = Number(rate || 0);
                const percent = (value * 100).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
                return percent + "%";
            },

        },
        mounted() {
            this.$POST("/customer/dataPanel/getShopCoreDataPanel/shops", {}).then(res => {
                this.shopList = res.data;
                this.$tools.getIndex(this.tableDataShop.column, "shopIds").tags = [{
                    value: -1,
                    type:'',
                    text: "全部",
                }];
                this.tableDataShop.form.shopIds = [-1];
                for (let i = 0; i < res.data.length; i++) {
                    this.$tools.getIndex(this.tableDataShop.column, "shopIds").tags.push({
                        value: res.data[i].id,
                        type:'',
                        text: res.data[i].shopName,
                    });
                    this.tableDataShop.form.shopIds.push(res.data[i].id)
                }
                this.getShop();
                this.getTheme();
                this.getMediaDownload();
            });
        },

        activated() {

        }
    }
</script>

<style scoped>

</style>
